function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "rg9kkhvsea"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  values: "0 0 0 0 0.329412 0 0 0 0 0.431373 0 0 0 0 0.478431 0 0 0 1.000000 0"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z",
  transform: "translate(-43 -361) translate(24 192) translate(19 25) translate(0 136) translate(0 8)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#546E7A",
  strokeWidth: 2,
  d: "M13 4c.552 0 1.052.224 1.414.586.362.362.586.862.586 1.414h0v14H3V6c0-.552.224-1.052.586-1.414C3.948 4.224 4.448 4 5 4h8zM19 8c.552 0 1.052.224 1.414.586.362.362.586.862.586 1.414h0v10h-6V8h4z",
  transform: "translate(-43 -361) translate(24 192) translate(19 25) translate(0 136) translate(0 8)"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#rg9kkhvsea)",
  transform: "translate(-43 -361) translate(24 192) translate(19 25) translate(0 136) translate(0 8)"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 0H2V2H0zM4 0H6V2H4zM0 4H2V6H0zM4 4H6V6H4zM0 8H2V10H0zM4 8H6V10H4z",
  transform: "translate(6 7)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#546E7A",
  d: "M10 4H12V6H10zM10 8H12V10H10z",
  transform: "translate(6 7)"
})))))))));
function Svg24BusinessCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24BusinessCenter);
export default __webpack_public_path__ + "static/media/24-business-center.b071464f7c2550f2006c16fc02342108.svg";
export { ForwardRef as ReactComponent };